import { InternalRedirectController } from './internal-redirect.controller';

export class InternalRedirectComponent implements ng.IComponentOptions {
  public controller: any;
  constructor() {
    this.controller = InternalRedirectController;
  }
}
